// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import NotFound from './components/NotFound';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Logout from './components/auth/Logout';
import PrivateRoute from './components/auth/PrivateRoute';
import Dashboard from './components/SaaS/Dashboard';
import Tasks from './components/Tasks';
import MeetDigis from './components/SaaS/MeetDigis';
import Explore from './components/SaaS/Explore';
import SoS from './components/SaaS/SoS';
import Profile from './components/SaaS/Profile';
import Outstaff from './components/SaaS/Outstaff/Outstaff';
import OutsourceRequests from './components/SaaS/Outsource/OutsourceRequests';
import MeetDigisGallery from './components/SaaS/MeetDigis';


const App = () => {
  return (
      <Router>
          <Navbar /> {/* Add the Navbar here !! */}
          <Routes>
              <Route path="/" element={<Home />} />
              <Route path="*" element={<NotFound />} /> {/* Fallback route for 404 Page */}
              <Route path="/login" element={<Login />} />
              <Route path="/registerdigiscustomer" element={<Register />} />
              <Route 
                    path="/dashboard" 
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    } 
                /> 
                <Route 
                    path="/project" 
                    element={
                        <PrivateRoute>
                            <OutsourceRequests />
                        </PrivateRoute>
                    } 
                /> 
                <Route 
                    path="/outstaff" 
                    element={
                        <PrivateRoute>
                            <Outstaff />
                        </PrivateRoute>
                    } 
                /> 
                <Route 
                    path="/tasks" 
                    element={
                        <PrivateRoute>
                            <Tasks />
                        </PrivateRoute>
                    } 
                /> 
                <Route 
                    path="/team" 
                    element={
                        <PrivateRoute>
                            <MeetDigis />
                        </PrivateRoute>
                    } 
                /> 
                <Route 
                    path="/explore" 
                    element={
                        <PrivateRoute>
                            <Explore />
                        </PrivateRoute>
                    } 
                /> 
                <Route 
                    path="/contact" 
                    element={
                        <PrivateRoute>
                            <SoS />
                        </PrivateRoute>
                    } 
                /> 
                <Route 
                    path="/profile" 
                    element={
                        <PrivateRoute>
                            <Profile />
                        </PrivateRoute>
                    } 
                /> 
                <Route 
                    path="/logout" 
                    element={
                        <PrivateRoute>
                            <Logout />
                        </PrivateRoute>
                    } 
                /> {/* Make Logout a private route */}
          </Routes>
      </Router>
  );
};

export default App;